import React, { useEffect } from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { WhatYouGet } from './components/WhatYouGet';
import { InAction } from './components/InAction';
import { NutritionCheck } from './components/NutritionCheck';
import { Pillars } from './components/Pillars';
import { SafeFoods } from './components/SafeFoods';
import { Transformation } from './components/Transformation';
import { Pricing } from './components/Pricing';
import { RecipeStudio } from './components/RecipeStudio';
import { BrandNote } from './components/BrandNote';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { initMetaPixel, addFacebookDomainVerification } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    addFacebookDomainVerification();
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-cream" data-id="element-0" data-mp="3ii4su47vuwpm">
      <Nav data-id="element-1" data-mp="3mkhn9wh6j873" />
      <main data-id="element-2" data-mp="3mk83iqmq9x9u">
        <Hero data-id="element-3" data-mp="3mjq2lgp4euvl" />
        <PainPoints data-id="element-4" data-mp="3mj6ibtbzzuee" />
        <Solution data-id="element-5" data-mp="3rcj6k2crlz6m" />
        <InAction data-id="element-6" data-mp="3rbzomln47asl" />
        <WhatYouGet data-id="element-7" data-mp="3rdkg22e4udm8" />
        <NutritionCheck data-id="element-8" data-mp="3rd189ei755lx" />
        <Pillars data-id="element-9" data-mp="5yi8qe3h5da" />
        <SafeFoods data-id="element-10" data-mp="6hovayao7c0" />
        <Transformation data-id="element-11" data-mp="4ww9qvjiygs" />
        <Pricing data-id="element-12" data-mp="56lvdcob3ly" />
        <RecipeStudio data-id="element-13" data-mp="7ssnarqpf34" />
        <BrandNote data-id="element-14" data-mp="2zld43f9knpe6" />
        <Faq data-id="element-15" data-mp="2zm4yimrfnh2v" />
        <FinalCta data-id="element-16" data-mp="2zmemy5wtxg6g" />
      </main>
      <Footer data-id="element-17" data-mp="2zng1ikd20ksx" />
      <StickyCta data-id="element-18" data-mp="33mowfsjtyoq2" />
    </div>;
}